import React, { useEffect, useState, useRef, useContext } from 'react';
import { GetDomain, RemoveCookie, GetCoockie, FormatCurrency, CheckSession, GetShoppingCart } from "../GlobalScript";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import $ from 'jquery';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ProgressBar from 'react-bootstrap/ProgressBar';
import PulseLoader from "react-spinners/PulseLoader";
import Modal from 'react-bootstrap/Modal';
import FooterDealer from '../FooterDealer.js';
import { ShoppingCartContext } from './ShoppingCartContext';

export default function AboutTheProgram() {

    const [UserInfo, setUserInfo] = useState(null);
    const [Year, setYear] = useState(null);

    useEffect(() => {    
        document.title = 'K-Dealer - About the Program';
    });

    return (
        <>
            <div className="banner banner-about">
                <Container>
                    <Row>
                        <Col lg={6} className="banner-content">
                            <h1 className="black-text">K-LOYALTY <br /> ABOUT THE PROGRAM</h1>

                            <div className="green-bg text-center heading padding-extra">
                                <h2 className="bold">PROGRAM DATES</h2>

                                <h3 className="bold">June 1, 2025 - March 31, 2026</h3>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container className="checkout-container main-container dealer-section">
                <Row className="mt-0 mb-4">
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <p>
                                    The <span className="bold">K-Loyalty</span> program continues to be a great success and Kawasaki Motor Corp., U.S.A.'s Parts and Accessories department
                                    is pleased to continue this program. This industry leading program rewards dealers who invest in Kawasaki genuine parts, accessories, oils, chemicals, 
                                    apparel, gifts, and collectibles. <br /><br /> The Kawasaki K-Loyalty program is designed to help your dealership maximize its profits by qualifying for
                                    free freight on Stocking Order Types, while also receiving a discount on those qualifying orders! It is important to stock high-demand products that match
                                    market needs, enhance consumers' showroom experience, while keeping your profit margins up.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col sm={12}>
                        <div className="card-tab-title">
                            <h3>KEY ADVANTAGES</h3>
                        </div>
                        <Card>
                            <Card.Body >
                                <Row className="card-group">
                                    <Col sm={3}>
                                        <Card className="card-group-item card-special-header">
                                            <Card.Title className="black-bg white-text green-border-bottom">STACKABLE DISCOUNTS</Card.Title>
                                            <Card.Body>
                                                <p className="text-center">Discounts are stackable with sales programs</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={3}>
                                        <Card className="card-group-item card-special-header">
                                            <Card.Title className="black-bg white-text green-border-bottom">AUTOMATIC DISCOUNT</Card.Title>
                                            <Card.Body>
                                                <p className="text-center">
                                                    When qualified as K-Loyalty tier Silver or higher, <span className="bold">discounts automatically apply</span> to
                                                    every parts and accessories 'Stocking' order type
                                                </p>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={3}>
                                        <Card className="card-group-item card-special-header">
                                            <Card.Title className="black-bg white-text green-border-bottom">FREE FREIGHT</Card.Title>
                                            <Card.Body>
                                                <p className="text-center">
                                                    <span className="bold">FREE</span> freight policy options provide competitive pricing - starting at Silver tier
                                                </p>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={3}>
                                        <Card className="card-group-item card-special-header">
                                            <Card.Title className="black-bg white-text green-border-bottom">TRACKABLE PROGRESS</Card.Title>
                                            <Card.Body>
                                                <p className="text-center">
                                                    Track your dealership's progress with our easy-to-read tools accessible on K-Dealer, or contact your PASR for assistance
                                                </p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
                <Row className="mb-4">
                    <Col sm={12}>
                        <div className="card-tab-title">
                            <h3>K-LOYALTY LEVELS AND QUALIFIERS</h3>
                        </div>
                        <Card>
                            <Card.Body className="order-table">
                                <Row>
                                    <Col sm={4}>
                                        <div className="green-bg text-center">
                                            <h4 className="bold">PLATINUM - GOLD - SILVER - BASE</h4>
                                        </div>
                                    </Col>

                                    <Col sm={8}>
                                        <p>
                                            Dealers must reach and maintain the minimum buy-in level on an MAT (Moving Annual Total) basis in each of the following categories to
                                            receive K-Loyalty discounts and shipping benefits.
                                        </p>
                                    </Col>
                                </Row>
                                
                                <Table hover responsive bordered>
                                    <thead>
                                        <tr className="table-row-black-bg table-row-svg">
                                            <th>
                                                <div className="svg-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7">
                                                        <path className="st2" d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
                                                    </svg>
                                                </div>
                                                K-LOYALTY TIER
                                            </th>
                                            <th>
                                                <div className="svg-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 230.6 220.6">
                                                        <path className="st2" d="M156.8,119h39.3v10.4h-39.3v-10.4ZM39,119h14.4v-14.4h10.5v14.4h14.4v10.4h-14.4v14.4h-10.5v-14.4h-14.4v-10.4ZM131.4,97.4l-10.3,24.2,12.6-.3-30.2,34.6,13.4-26.4h-13.4l27.8-32.1ZM19.4,204h196v-125.7H19.4v125.7Z" />
                                                        <rect className="st2" x="9.6" y="55.5" width="213.4" height="15" />
                                                        <g>
                                                            <g class="st2">
                                                                <g >
                                                                    <path d="M58.7,37.3v13h-22.8v-13c0-6.3,5.1-11.4,11.4-11.4,6.3,0,11.4,5.1,11.4,11.4" />
                                                                    <path d="M196.1,37.3v13h-22.8v-13c0-6.3,5.1-11.4,11.4-11.4,0,0,0,0,0,0,3,0,5.9,1.2,8.1,3.3,2.2,2.1,3.4,5,3.3,8.1" />
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </div>
                                                PARTS & ACCESSORIES
                                            </th>
                                            <th>
                                                <div className="svg-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 230.6 220.6">
                                                        <path className="st2" d="M115.8,41.3l33.6-.4c12.8,41.7,5.7,169,5.7,169l-87.6-.7-.2-107.3c1.5-24.2,24.4-39.7,44.9-51.8,2.9-2.3,3.6-8.6,3.6-8.6Z" />
                                                        <path className="st2" d="M116.1,41.3h33.1c12.8,41.7,5.7,169,5.7,169l-87.6-.7-.2-107.3c1.5-24.2,24.4-39.7,44.9-51.8,2.9-2.3,4.1-9.1,4.1-9.1Z" />
                                                        <path className="st2" d="M118.2,22.9h29.8c1.8,0,2.1,3.6,2,5.4,0,3.3-.1,11.4-.1,11.4l-33.9.5v-15.1c.3-1.4,2.2-2.2,2.2-2.2Z" />
                                                        <path d="M181.7,44.7" />
                                                        <path d="M115.8,41.3l33.6-.4c.4,5,3.4,18.5,4.2,24.8s5.6,45.2,3.9,47.7-19.6,43.2-2,66.5c2.1,3.1,1.5,25.2,1.5,25.2,0,9.3-7.7,9.8-11.2,10.2-10.4.4-66.2,1-66.2,1-8.4,0-11.7-3.1-12.7-10.6s0-35,0-35c2.7-1.3,12.9-14.7-.4-47-1-5,1.5-27.4,1.5-27.4,0,0,9-.1,10.1-7.8,0-3.1-2.6-8.5-.7-11.2s5-6.1,6.1-6.4,4.8,4.2,8.1,3.3,5.5-5.6,5.9-6.9-.8-8.3.8-9,13.7-7.6,15.7-10.7,1.8-6.1,1.8-6.1Z" />
                                                        <path className="st2" d="M115.8,41.3h33.1c.4,5,3.4,18.5,4.2,24.8s5.6,45.2,3.9,47.7-19.6,43.2-2,66.5c2.1,3.1,1.5,25.2,1.5,25.2,0,9.3-7.7,9.8-11.2,10.2-10.4.4-66.2,1-66.2,1-8.4,0-11.7-3.1-12.7-10.6s0-35,0-35c2.7-1.3,12.9-14.7-.4-47-1-5,1.5-27.4,1.5-27.4,0,0,9-.1,10.1-7.8,0-3.1-2.6-8.5-.7-11.2s5-6.1,6.1-6.4,4.8,4.2,8.1,3.3,5.5-5.6,5.9-6.9-.8-8.3.8-9,13.7-7.6,15.7-10.7,2.3-6.6,2.3-6.6Z" />
                                                        <path className="st2" d="M115.8,41.3h33.1c.4,5,3.4,18.5,4.2,24.8s5.6,45.2,3.9,47.7-19.6,43.2-2,66.5c2.1,3.1,1.5,25.2,1.5,25.2,0,9.3-7.7,9.8-11.2,10.2-10.4.4-66.2,1-66.2,1-8.4,0-11.7-3.1-12.7-10.6s0-35,0-35c2.7-1.3,12.9-14.7-.4-47-1-5,1.5-27.4,1.5-27.4,0,0,9-.1,10.1-7.8,0-3.1-2.6-8.5-.7-11.2s5-6.1,6.1-6.4,4.8,4.2,8.1,3.3,5.5-5.6,5.9-6.9-.8-8.3.8-9,13.7-7.6,15.7-10.7,2.3-6.6,2.3-6.6Z" />
                                                        <path className="st2" d="M116.1,41.3h33.1c.4,5,3.4,18.5,4.2,24.8s5.6,45.2,3.9,47.7-19.6,43.2-2,66.5c2.1,3.1,1.5,25.2,1.5,25.2,0,9.3-7.7,9.8-11.2,10.2-10.4.4-66.2,1-66.2,1-8.4,0-11.7-3.1-12.7-10.6s0-35,0-35c2.7-1.3,12.9-14.7-.4-47-1-5,1.5-27.4,1.5-27.4,0,0,9-.1,10.1-7.8,0-3.1-2.6-8.5-.7-11.2s5-6.1,6.1-6.4,4.8,4.2,8.1,3.3,5.5-5.6,5.9-6.9-.8-8.3.8-9,13.7-7.6,15.7-10.7,2.3-6.6,2.3-6.6Z" />
                                                        <path className="st1" d="M122.5,65.4c-11.9,5.4-39.7,16.7-42.6,48.4-1.4,39.5,0,78.1,0,78.1-.2,6.1,4.7,7,13.3,6.5s44.6.5,46.6.1,6.3-11.7,2.5-22.1c-3.3-16.8-6.3-31.5-1.6-47,5.8-13.5,3.9-48.1-10.5-62.6s-5.1-2.6-7.8-1.4Z" />
                                                        <polygon className="st0" points="82.9 152.5 90.7 152.5 90.7 164 87.4 164 87.3 157.8 86.1 157.8 86.1 165 94.6 165 94.6 170.3 82.9 170.3 82.9 152.5" />
                                                        <path className="st0" d="M94.6,132.7h-12v19.1h12.3l-.3-19.1ZM91.4,146.2h-5.2v-8.1h5.2v8.1Z" />
                                                        <polygon className="st0" points="94.6 171.4 94.6 176.6 90.2 176.6 90.2 183.6 94.6 183.6 94.6 189 82.9 189 82.9 183.7 87.2 183.7 87.2 182.6 82.9 176.8 82.9 170.8 86.9 175.3 86.9 171.2 94.6 171.4" />
                                                        <path className="st2" d="M149.8,39.6h-33.9v-14.6" />
                                                    </svg>
                                                </div>
                                                OIL & CHEMICALS
                                            </th>
                                            <th>
                                                <div className="svg-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 230.6 220.6">
                                                        <g className="st2">
                                                            <g>
                                                                <path d="M130.7,90.7c-.4,0-.7.3-.7.7,0,0,0,0,0,0h1.4c0-.4-.3-.7-.6-.7,0,0,0,0,0,0" />
                                                                <path d="M91.8,82.8c1.2-.3,1.1-2,1.1-2,0,0-1.3.4-2,.7s-.4.9-.4.9c.3.4.8.5,1.2.4" />
                                                                <path d="M139.4,89.7h-.9v1.2h.9c.5,0,.7-.2.7-.6s-.3-.6-.7-.6" />
                                                                <path d="M143.2,90.7c-.5,0-.8.4-.8,1s.3,1,.8,1,.8-.4.8-1-.3-1-.8-1" />
                                                                <path d="M84.3,90.7c-.4,0-.7.3-.7.7,0,0,0,0,0,0h1.4c0-.4-.3-.7-.6-.7,0,0,0,0,0,0" />
                                                                <path d="M107.4,90.7c-.5,0-.8.4-.8,1s.3,1,.8,1,.8-.4.8-1-.3-1-.8-1" />
                                                                <path d="M113.5,82.4c.3.4.8.5,1.2.4,1.2-.3,1.1-2,1.1-2,0,0-1.3.4-2,.7s-.4.9-.4.9" />
                                                                <path d="M111.1,90.7c-.5,0-.8.4-.8,1s.3,1,.8,1,.8-.4.8-1-.3-1-.8-1" />
                                                                <path d="M97.8,90.7c-.4,0-.7.3-.7.7,0,0,0,0,0,0h1.4c0-.4-.3-.7-.6-.7,0,0,0,0,0,0" />
                                                                <path d="M114.8,90.8c-.4,0-.7.4-.7,1s.2.9.7.9.7-.4.7-.9-.2-1-.7-1" />
                                                                <path d="M149.8,88.9c-.1,0-.2,0-.3,0-.1,0-.2,0-.3,0,0,0-.2.1-.2.2-.1.2-.1.5,0,.7,0,0,.1.2.2.2,0,0,.2,0,.3,0,.1,0,.2,0,.3,0,0,0,.2-.1.2-.2.1-.2.1-.5,0-.7,0,0-.1-.2-.2-.2M149.7,89.9l-.2-.3h0v.3h-.2v-.9h.3c.3,0,.4,0,.4.3,0,0,0,.1,0,.2,0,0,0,0-.1,0l.2.4h-.2Z" />
                                                                <path d="M149.6,89.2s0,0-.1,0h0v.3h0c.1,0,.2,0,.2-.1,0,0,0,0,0,0" />
                                                                <path d="M188.4,22.2l-20.1-6.6c-7.9-1.2-16-.7-23.7,1.7-19.5,35.4-50.3,17-56.1-2.5C49.2.2,11.1,64.9,11.1,64.9l-9.1,10,51.2,33.1,1.6.9-.2,104.8h112.2l11.2-2.8,1.1-102,51.2-36.1-41.9-50.7ZM133,78c-.6,0-1.2.4-1.2,1.1,0,0,0,.1,0,.2h-3.1s-.7-3.4,4.5-3.4c0,0,3.8-.2,4,2.7s-.2,5,.7,6.1h-3.3c-.2-.2-.3-.5-.5-.8-.7.7-1.7,1.1-2.8,1-1.4.2-2.7-.8-2.9-2.2,0,0,0-.2,0-.3,0-1.4.8-2.5,3.5-2.9,1.1-.2,2-.3,2-.9s-.8-.7-1-.7M99.4,76.3l1.2,3.9,1.2-3.9h2.9l1.1,3.9,1.3-3.9h3.3l-2.6,8.4h-3.3l-1.3-4.1-1.1,4.1h-3.4l-2.9-8.4h3.5ZM79.5,84.7h-3.5v-11.6h3.5v3.5l3.5-3.5h4.4l-4.5,4.6,4.8,7h-4.6l-2.8-4.4-.9.9v3.4ZM82.4,93.3h-2.9v-4.3h.9v3.6h2v.7ZM84.3,92.7c.3,0,.5-.1.6-.4h.8c-.2.6-.7,1.1-1.4,1-.9,0-1.6-.8-1.6-1.7,0-.8.7-1.5,1.5-1.6,1,0,1.5.8,1.5,1.9h-2.2c0,.4.3.8.7.8,0,0,0,0,0,0M88,93.3h-.5c-.4,0-.8-.2-.8-.7v-1.8h-.4v-.6h.4v-1h.8v1h.5v.6h-.5v1.6c0,.2,0,.3.2.3,0,0,0,0,0,0h.2v.6ZM87.3,82.5c0-1.4.8-2.5,3.4-2.9,1.1-.2,2-.3,2-.9s-.8-.7-1-.7c-.6,0-1.2.4-1.2,1.1,0,0,0,.1,0,.2h-3.1s-.7-3.4,4.5-3.4c0,0,3.8-.2,4,2.7s-.2,5,.7,6.1h-3.3c-.2-.2-.3-.5-.5-.8-.7.7-1.7,1.1-2.8,1-1.4.2-2.7-.8-2.9-2.2,0,0,0-.2,0-.3M92,93.3h-.5c-.4,0-.8-.2-.8-.7v-1.8h-.4v-.6h.4v-1h.8v1h.5v.6h-.5v1.6c0,.2,0,.3.2.3,0,0,0,0,0,0h.2v.6ZM95.6,93.3h-.8v-1.9c0-.3-.2-.5-.5-.6,0,0,0,0,0,0-.4,0-.6.3-.6.7,0,0,0,0,0,0v1.7h-.8v-4.3h.8v1.6h0c.2-.3.5-.5.9-.5.6,0,1.1.5,1.1,1,0,0,0,0,0,.1v2ZM97.8,92.7c.3,0,.5-.1.6-.4h.8c-.2.6-.7,1.1-1.4,1-.9,0-1.6-.8-1.6-1.7,0-.8.7-1.5,1.5-1.6,1,0,1.5.8,1.5,1.9h-2.2c0,.4.3.8.8.8,0,0,0,0,0,0M105.2,93.3h-.7v-.6h0c-.2.4-.7.7-1.2.7-.6,0-1.1-.2-1.5-.6-.8-1-.7-2.4.1-3.3.4-.3.9-.5,1.4-.5.9,0,1.7.5,1.8,1.4h-.9c0-.4-.5-.8-1-.7-.8,0-1.2.7-1.2,1.5s.5,1.5,1.2,1.5c.6,0,1.1-.4,1.1-1h0s-1,0-1,0v-.7h1.8v2.3ZM107.4,93.4c-.9,0-1.6-.7-1.6-1.6,0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6c0,0,0,0,0,0,0,.9-.6,1.6-1.5,1.6,0,0,0,0-.1,0M111.1,93.4c-.9,0-1.6-.7-1.6-1.6,0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6c0,0,0,0,0,0,0,.9-.6,1.6-1.5,1.6,0,0,0,0-.1,0M116.3,93.3h-.8v-.4h0c-.2.3-.5.5-.9.5-.8,0-1.3-.6-1.3-1.6s.6-1.6,1.3-1.6c.4,0,.7.2.9.5h0v-1.6h.8v4.3ZM115.9,83.9c-.7.7-1.7,1.1-2.8,1-1.4.2-2.7-.8-2.9-2.2,0,0,0-.2,0-.3,0-1.4.8-2.5,3.4-2.9,1.1-.2,2-.3,2-.9s-.8-.7-1-.7c-.6,0-1.2.4-1.2,1.1,0,0,0,.1,0,.2h-3.1s-.7-3.4,4.5-3.4c0,0,3.8-.2,4,2.7s-.2,5,.7,6.1h-3.3c-.2-.2-.3-.5-.5-.8M121.6,89.7h-1.3v3.6h-.9v-3.6h-1.3v-.7h3.4v.7ZM123,93.3h-.8v-3.1h.8v3.1ZM123,89.7h-.8v-.7h.8v.7ZM119.5,81.8h3.1c0,.7.5,1.3,1.2,1.3,0,0,0,0,0,0,1.1,0,1-.6,1-.6,0,0,0-.6-1.1-.8-1.3-.2-4.1-.4-4.1-2.8,0,0-.2-2.9,4.1-2.9s4.1,1.3,4.1,2.9h-2.9c0-.5-.5-.9-1.1-.9-.6,0-1,.2-1,.5s.2.6,2,.8c2.1.4,3.2.9,3.2,3.1s-2.2,2.8-4.2,2.8-4.4-.7-4.4-3.3M128.5,93.3h-.8v-1.9c0-.3-.2-.5-.5-.5s-.6.3-.6.7v1.8h-.8v-1.9c0-.3-.2-.5-.5-.5s-.6.3-.6.7v1.8h-.8v-3.1h.8v.4h0c.2-.3.5-.5.9-.5.4,0,.7.2.9.5h0c.2-.3.5-.5.9-.5.5,0,1,.4,1,.9,0,0,0,.1,0,.2v2.1ZM130.7,92.7c.3,0,.5-.1.6-.4h.8c-.2.6-.7,1.1-1.4,1-.9,0-1.6-.8-1.6-1.7,0-.8.7-1.5,1.5-1.6,1,0,1.5.8,1.5,1.9h-2.2c0,.4.3.8.8.8,0,0,0,0,0,0M134.2,93.4c-.9,0-1.4-.4-1.4-1.1h.8c0,.3.3.6.7.5,0,0,0,0,0,0,.4,0,.6-.1.6-.4s-.4-.3-.8-.4c-.6-.1-1.1-.3-1.1-.9s.6-1,1.3-1,1.3.4,1.3,1h-.7c0-.3-.2-.4-.6-.4s-.5.1-.5.3.4.3.8.4c.5.1,1.1.3,1.1,1s-.5,1-1.3,1M140.2,93.3l-1-1.7h-.7v1.7h-.9v-4.3h1.9c.4,0,.8.1,1.1.4.2.2.4.6.4.9,0,.5-.3,1-.9,1.2l1.1,1.8h-1ZM141.6,84.7h-3.4v-11.6h3.4v5.2l1.7-2h4l-2.9,3.1,3.4,5.3h-3.9l-1.9-2.8-.4.5v2.4ZM143.2,93.4c-.9,0-1.6-.7-1.6-1.6,0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6c0,0,0,0,0,0,0,.9-.6,1.6-1.5,1.6,0,0,0,0-.1,0M146.4,93.3h-.8v-4.3h.8v4.3ZM148.1,93.3h-.8v-4.3h.8v4.3ZM150.2,89.9c0,.1-.2.2-.3.3-.3.1-.6.1-.8,0-.1,0-.2-.2-.3-.3,0-.1-.1-.3-.1-.4,0-.1,0-.3.1-.4,0-.1.2-.2.3-.3.3-.1.6-.1.8,0,.1,0,.2.2.3.3,0,.1.1.3.1.4,0,.1,0,.3-.1.4M151.5,84.7h-3.4v-8.4h3.4v8.4ZM151.5,75.5h-3.4v-2.4h3.4v2.4Z" />
                                                                <path d="M131.7,82.4c.3.4.8.5,1.2.4,1.2-.3,1.1-2,1.1-2,0,0-1.3.4-2,.7s-.4.9-.4.9" />
                                                                <path className="st11" d="M228.2,76.8c1.8-1.3,2.3-3.8,1-5.6,0,0-.1-.2-.2-.2-8.1-10.1-31.8-39.5-38.6-46.3-5.9-6.6-22.4-12.6-43.6-9-1.3.3-2.5,1.1-3,2.4-14.3,31-49.7,18.9-55.7-1.3-.5-1.5-1.7-2.5-3.3-2.7-13.6-2.2-34.3,1.2-45.7,15.4L3.5,72.3c-1.4,1.7-1.2,4.3.5,5.7.1.1.3.2.4.3l49.8,31.4h.1l.2,99.9c0,2.2,1.8,4.1,4.1,4.1h116.6c2.2,0,4.1-1.8,4.1-4.1,0,0,0,0,0,0l-.4-96.5c0-1.3.6-2.6,1.7-3.4l47.6-33Z" />
                                                                <line className="st0" x1="54.2" y1="109.7" x2="54.2" y2="69.6" />
                                                                <line className="st11" x1="54.2" y1="109.7" x2="54.2" y2="69.6" />
                                                                <line className="st0" x1="178.8" y1="112.7" x2="178.8" y2="72.6" />
                                                                <line className="st11" x1="178.8" y1="112.7" x2="178.8" y2="72.6" />
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </div>
                                                APPAREL & GIFTS
                                            </th>
                                            <th>
                                                DISC %
                                            </th>
                                            <th>
                                                FREE FREIGHT
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="green-bg bold">Platinum</td>
                                            <td className="green-bg bold">$200,000+</td>
                                            <td className="green-bg bold">$12,000+</td>
                                            <td className="green-bg bold">$2,400+</td>
                                            <td className="green-bg bold">4%</td>
                                            <td rowSpan="3">$100+</td>
                                        </tr>
                                        <tr>
                                            <td className="gold-bg bold">Gold</td>
                                            <td className="gold-bg bold">$125,000 - $199,999.99</td>
                                            <td className="gold-bg bold">$7,500 - $11,999.99</td>
                                            <td className="gold-bg bold">$1,200 - $2,399.99</td>
                                            <td className="gold-bg bold">3%</td>
                                        </tr>
                                        <tr>
                                            <td className="gray-bg bold">Silver</td>
                                            <td className="gray-bg bold">$70,000 - $124,999.99</td>
                                            <td className="gray-bg bold">$4,200 - $7,499.99</td>
                                            <td className="gray-bg bold">$600 - $1,199.99</td>
                                            <td className="gray-bg bold">2%</td>
                                        </tr>
                                        <tr>
                                            <td>Base</td>
                                            <td>$0 - $69,999.99</td>
                                            <td>$0 - $4,199.99</td>
                                            <td>$0 - $599.99</td>
                                            <td>0%</td>
                                            <td>N/A</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col sm={12}>
                        <div className="card-tab-title">
                            <h3>ACTION REQUIRED BY DEALER*:</h3>
                        </div>
                        <Card>
                            <Card.Body>
                                <p>
                                    Simply review your "K-Loyalty Program Summary" to find out where you stand today. You can find this information on K-Dealer's Home screen under the
                                    Quick Links or from the P&A tab.
                                </p>
                                <h3 className="bold">Exclusions:</h3>
                                <ul>
                                    <li>Demo Program</li>
                                    <li>Curtic Cabs</li>
                                    <li>Accessory Packages</li>
                                    <li>Fleet and Government Programs</li>
                                </ul>

                                <p>
                                    *All program elements, interpretation of rules, and substitution, modification, or withdrawal of any program element are at the sole and absolute
                                    discretion of Kawasaki Motors Corp., U.S.A.
                                </p>
                            </Card.Body>
                            <div className="gray-bg padding-extra-lg">
                                <p className="mb-0">
                                    For a complete listing of all current Kawasaki sales programs, please see our comprehensive eBinder on <a href="https://k-dealer.com" className="bold black-text" target="_blank" rel="noreferrer">k-dealer.com</a>
                                </p>
                            </div>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col sm={12}>
                        <Card>
                            <Card.Body className="order-table">
                                <Table hover responsive bordered>
                                    <thead>
                                        <tr className="table-row-black-bg">
                                            <th>
                                                TIER
                                            </th>
                                            <th>
                                                ORDER TYPE
                                            </th>
                                            <th>
                                                ORDER VALUE
                                            </th>
                                            <th>
                                                UPS STANDARD
                                            </th>
                                            <th>
                                                LTL
                                            </th>
                                            <th>
                                                1-DAY
                                            </th>
                                            <th>
                                                2-DAY
                                            </th>
                                            <th>
                                                PER LINE FEE
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td rowSpan="7" className="green-bg bold">Platinum</td>
                                            <td>Stocking</td>
                                            <td>$0.00 and UP</td>
                                            <td>$8.95</td>
                                            <td>$28.95</td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Regular</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$11.95</td>
                                            <td rowSpan="3">$31.95</td>
                                            <td>$34.00</td>
                                            <td>$22.00</td>
                                            <td rowSpan="3" className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$59.00</td>
                                            <td>$34.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$85.00</td>
                                            <td>$59.00</td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Emergency</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$12.95</td>
                                            <td rowSpan="3">$35.95</td>
                                            <td>$34.00</td>
                                            <td>$22.00</td>
                                            <td rowSpan="3">$2.00 <br /> ($20.00 Max)</td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$59.00</td>
                                            <td>$34.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$85.00</td>
                                            <td>$59.00</td>
                                        </tr>

                                        <tr>
                                            <td rowSpan="7" className="gold-bg bold">Gold</td>
                                            <td>Stocking</td>
                                            <td>$0.00 and UP</td>
                                            <td>$10.95</td>
                                            <td>$30.95</td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Regular</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$13.95</td>
                                            <td rowSpan="3">$33.95</td>
                                            <td>$39.00</td>
                                            <td>$27.00</td>
                                            <td rowSpan="3" className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$64.00</td>
                                            <td>$39.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$90.00</td>
                                            <td>$64.00</td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Emergency</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$14.95</td>
                                            <td rowSpan="3">$37.95</td>
                                            <td>$39.00</td>
                                            <td>$27.00</td>
                                            <td rowSpan="3">$3.00 <br /> ($30.00 Max)</td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$64.00</td>
                                            <td>$39.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$90.00</td>
                                            <td>$64.00</td>
                                        </tr>

                                        <tr>
                                            <td rowSpan="7" className="gray-bg bold">Silver</td>
                                            <td>Stocking</td>
                                            <td>$0.00 and UP</td>
                                            <td>$12.95</td>
                                            <td>$32.95</td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Regular</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$15.95</td>
                                            <td rowSpan="3">$35.95</td>
                                            <td>$44.00</td>
                                            <td>$32.00</td>
                                            <td rowSpan="3" className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$69.00</td>
                                            <td>$44.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$95.00</td>
                                            <td>$69.00</td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Emergency</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$16.95</td>
                                            <td rowSpan="3">$39.95</td>
                                            <td>$44.00</td>
                                            <td>$32.00</td>
                                            <td rowSpan="3">$4.00 <br /> ($40.00 Max)</td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$69.00</td>
                                            <td>$44.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$95.00</td>
                                            <td>$69.00</td>
                                        </tr>

                                        <tr>
                                            <td rowSpan="7">Base</td>
                                            <td>Stocking</td>
                                            <td>$0.00 and UP</td>
                                            <td>$14.95</td>
                                            <td>$34.95</td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                            <td className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Regular</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$17.95</td>
                                            <td rowSpan="3">$37.95</td>
                                            <td>$49.00</td>
                                            <td>$37.00</td>
                                            <td rowSpan="3" className="silver-bg"></td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$74.00</td>
                                            <td>$49.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$99.00</td>
                                            <td>$74.00</td>
                                        </tr>
                                        <tr>
                                            <td rowSpan="3">Emergency</td>
                                            <td>$0.00 - 99.99</td>
                                            <td rowSpan="3">$18.95</td>
                                            <td rowSpan="3">$41.95</td>
                                            <td>$49.00</td>
                                            <td>$37.00</td>
                                            <td rowSpan="3">$5.00 <br /> ($50.00 Max)</td>
                                        </tr>
                                        <tr>
                                            <td>$100.00 - 299.99</td>
                                            <td>$74.00</td>
                                            <td>$49.00</td>
                                        </tr>
                                        <tr>
                                            <td>$300.00 and UP</td>
                                            <td>$99.00</td>
                                            <td>$74.00</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col sm={12}>
                        <div className="card-tab-title">
                            <h3>TIPS FOR MAXIMIZING PROFITS</h3>
                        </div>
                        <Card>
                            <Card.Body>
                                <p>
                                    Although this is a monthly program, your dealership can maintain the K-Loyalty categories on a quarterly or semi-annual basis. Plan ahead; review the K-Loyalty
                                    dashboard on K-Dealer and see what is scheduled to drop off in the coming months.
                                </p>
                                <h3 className="bold">EXAMPLE OF ESTIMATED ANNUAL SAVINGS:</h3>

                                <div className="order-table">
                                    <Table hover responsive bordered>
                                        <thead>
                                            <tr className="table-row-black-bg">
                                                <th>K-LOYALTY</th>
                                                <th>ANNUAL <br /> TTL ORDER <br /> $</th>
                                                <th>AVG <br /> ORDER <br /> VALUE</th>
                                                <th># OF ANNUAL <br /> ORDERS</th>
                                                <th>EST 40% <br /> STOCKING ORDERS</th>
                                                <th>FREE <br /> FREIGHT <br /> SAVINGS</th>
                                                <th>DISCOUNT <br /> SAVINGS</th>
                                                <th>TOTAL <br /> SAVINGS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="green-bg bold">Platinum</td>
                                                <td>$200,000</td>
                                                <td>$800</td>
                                                <td>250</td>
                                                <td>100</td>
                                                <td>$1,495</td>
                                                <td>$3,200</td>
                                                <td>$4,695</td>
                                            </tr>
                                            <tr>
                                                <td className="gold-bg bold">Gold</td>
                                                <td>$125,000</td>
                                                <td>$500</td>
                                                <td>250</td>
                                                <td>100</td>
                                                <td>$1,495</td>
                                                <td>$1,500</td>
                                                <td>$2,995</td>
                                            </tr>
                                            <tr>
                                                <td className="gray-bg bold">Silver</td>
                                                <td>$70,000</td>
                                                <td>$280</td>
                                                <td>250</td>
                                                <td>100</td>
                                                <td>$1,495</td>
                                                <td>$560</td>
                                                <td>$2,055</td>
                                            </tr>
                                            <tr>
                                                <td>Base</td>
                                                <td className="silver-bg"></td>
                                                <td className="silver-bg"></td>
                                                <td className="silver-bg"></td>
                                                <td className="silver-bg"></td>
                                                <td>$0.00</td>
                                                <td>$0.00</td>
                                                <td>$0.00</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>

                                <p>
                                    The above are very simplified examples that show potential savings. Savings will vary from dealer to dealer as this
                                    is based on how many orders are processed as a 'Stocking Order Type'. The more Stocking Orders processed,
                                    will result in larger annual savings. 
                                </p>

                                <p className="mb-0">Short on Total Parts & Accessories?</p>
                                <ul>
                                    <li>Gradual growth for sustainability
                                        <ul>
                                            <li>Plan purchases out over time to reach the total gradually; this will help when you maintain that total value, saving month to month</li>
                                        </ul>
                                    </li>
                                    <li>Accessorize units on the floor to maximize profits
                                        <ul>
                                            <li>Side by Side: add Roofs, Windshields, Winches, Bumpers</li>
                                            <li>Motorcycle: add Exhausts, Seat Cowls, Side Cases, Tank Pads, Covers</li>
                                            <li>ATV: add Winches, Brush guard, Cargo Box, Covers</li>
                                            <li>Jet Ski Watercraft: add Audio, Storage Bags, Covers</li>
                                        </ul>
                                    </li>
                                    <li>Kawasaki Genuine Parts
                                        <ul>
                                            <li>Utilize Kawasaki Genuine Parts for sales & service. Guaranteed fit!</li>
                                        </ul>
                                    </li>
                                    <li>Sales totals from Oil & Chemicals and Apparel & Gifts count towards your total Parts & Accessories sales total</li>
                                </ul>

                                <p className="mb-0">Short on Oils & Chemicals?</p>
                                <ul>
                                    <li>Utilize KPO in the service department</li>
                                    <li>Stock KPO Oil Change Kits for over-the-counter customers and in the Service department</li>
                                </ul>

                                <p className="mb-0">Short on Apparel & Gifts?</p>
                                <ul>
                                    <li>Utilize Kawasaki apparel as a sales tool to drive traffic and build on customer loyalty, for example:
                                        <ul>
                                            <li>Free Kawasaki hat with an Oil Change</li>
                                            <li>Free Kawasaki hat with purchase of a Kawasaki unit</li>
                                        </ul>
                                    </li>
                                    <li>If you have employees interested in purchasing Kawasaki apparel, utilize the personnel program as those will also count towards your apparel & gifts category</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />
        </>
    );
}